export enum BedType {
    icuLow = 'icu_low',

    icuHigh = 'icu_high',

    ecmo = 'ecmo'
}
